var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapBlMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map_bl_md",
    transform: "translate(-1305 -269)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11037",
    "data-name": "Rectangle 11037",
    width: 36,
    height: 36,
    rx: 12,
    transform: "translate(1305 269)",
    fill: "#0078d7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "map_black_24dp",
    transform: "translate(1311 275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46208",
    "data-name": "Path 46208",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46209",
    "data-name": "Path 46209",
    d: "M14.65,4.98l-5-1.75a2,2,0,0,0-1.3-.01L4.36,4.56A2.014,2.014,0,0,0,3,6.46V18.31a1.993,1.993,0,0,0,2.72,1.86l2.93-1.14a.966.966,0,0,1,.69-.01l5,1.75a2,2,0,0,0,1.3.01l3.99-1.34a2,2,0,0,0,1.36-1.9V5.69a1.993,1.993,0,0,0-2.72-1.86L15.34,4.97a1.021,1.021,0,0,1-.69.01ZM15,18.89,9,16.78V5.11l6,2.11Z",
    fill: "#0078d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBlMd);
export default __webpack_public_path__ + "static/media/map_bl_md.9838d6c5e1d1411965b7258f65e37fcd.svg";
export { ForwardRef as ReactComponent };